module.exports = __webpack_public_path__ + "images/emoji/beers.963fefb210a1319cd735.png";